import {Booking} from "@/services/booking.service";
import {Group} from "@/services/group.service";
import {Confirm} from "@/services/api.service";
import {KeycloakService} from "@/services/keycloak.service";
import moment from "moment";
import InputButton from "@/components/input-button/InputButton";

export default {
    name: 'BookingSummary',

    components: {
        InputButton,

    },
    props: {
        booking: Booking,
        selectedGroup: Group,
        pickedFiles: Array,
        bookingFiles: Array,

    },

    data() {
        return {
            isAllowedToSms: false,
        }
    },

    async mounted() {
        if (!KeycloakService.isBookingAgent()) {
            this.isAllowedToSms = true
        }
    },

    computed: {
        isBookingAgent() {
            return KeycloakService.isBookingAgent()
        },
        showDeclineButton() {
            return this.booking.status && this.booking.status.id == '1' && !this.isBookingAgent
        },

        groupedBookingOptions() {
            return this.filterOptionsArray(this.booking?.options?.sort((a, b) => a.id - b.id)) ?? []
        }
    },

    methods: {

        formatArrivalDate() {
            return moment(this.booking.arrivalDate).format('DD-MM-YYYY')
        },

        formatTimeSlots() {
            const startTime = moment(this.booking.entity.startDate).format('HH:mm')
            const endTime = moment(this.booking.entity.endDate).format('HH:mm')
            return `${startTime} - ${endTime}`
        },

        formatRecurringEndDate() {
            return moment(this.booking.recurringEndDate).format('DD-MM-YYYY')
        },

        formatBookingOptionDate(value) {
            return moment(value).format('DD-MM-YYYY HH:mm:ss')
        },
        sendSMS: async function(phoneNumber) {
            this.$parent.sms.phoneNumber = phoneNumber
            this.$parent.sms.message = ""
            this.$parent.showSmsCard = true
        },
        bookingOptionIsOfType(bookingOption, type) {
            console.log('booking option')
            console.log(bookingOption)
            return type.toLowerCase() == bookingOption.type.toLowerCase();
        },


        doBack() {
            this.$parent.showSummary = false
            window.scrollTo(0,0)
        },

        isRequested() {
            return (this.status && this.status.id == 1) || this.id == undefined
        },

        loadDeclineCard() {
            this.$parent.confirm = new Confirm({
                title: 'Decline this booking?',
                message: 'You are about to decline this visit. This action cannot be undone.'
            })

            this.$parent.toggleCard()
        },

        loadCancelCard() {
            this.$parent.confirm = new Confirm({
                title: 'Cancel this booking?',
                message: 'You are about to cancel this visit. This action cannot be undone.'
            })

            this.$parent.toggleCard()
        },

        doConfirm(status) {
            this.$parent.doConfirm(status)
        },

        downloadFile(file){
            this.$parent.downloadFile(file)
        },

        /** Decide wether or not to display options if they are forsuperuser only
         *
         * there are several cases to distinguish when a booking option has the property isForSuperuser == true
         *
         * case 1: user is not a booking agent =>   always show
         *
         * case 2: user is a booking agent creating a new booking (this.booking.id is undefined)=> do not show option and value
         *
         * case 3: user is a booking agent updating the booking => if the bookingoption  has no value (empty string
         * or null) , then hide it
         *
         * case 4: user is a booking agent updating the booking => if it has a value (which has been set by a superuser
         * prior) , then display its value
         *
         * @param bookingOption
         * @returns {boolean}
         */
        showIfForSuperUser (bookingOption) {

            if (bookingOption.isForSuperUser === true) {
                if (!KeycloakService.isBookingAgent()) {
                    //case 1
                    return !(bookingOption.value == "" || bookingOption.value == undefined)
                } else {
                    //case 2
                    if(!this.booking.id){
                        return false
                    //case 3
                    } else if(bookingOption.value == "" || bookingOption.value == undefined){
                        return false
                    } else {
                    //case 4
                        return true
                    }
                    return false
                }

                //none of the cases
            } else {
                return true
            }
        },
        filterOptionsArray(data) {
            const result = []

            data.forEach((obj) => {
                if (result.find((option) => { return option.id === obj.id})) {
                    const valueExists = result.find((option) => { return (option.id === obj.id && option.value == obj.value)})
                    if (valueExists == undefined) {
                        result.push(obj)
                    }
                } else {
                    result.push(obj)
                }
            })

            return result
        }
    },


}

